// extracted by mini-css-extract-plugin
export var bubble = "_l-0";
export var container = "_l-f";
export var contrastBorder = "_l-g";
export var greyOut = "_l-2";
export var initialsColor0 = "_l-3";
export var initialsColor1 = "_l-4";
export var initialsColor10 = "_l-d";
export var initialsColor11 = "_l-e";
export var initialsColor2 = "_l-5";
export var initialsColor3 = "_l-6";
export var initialsColor4 = "_l-7";
export var initialsColor5 = "_l-8";
export var initialsColor6 = "_l-9";
export var initialsColor7 = "_l-a";
export var initialsColor8 = "_l-b";
export var initialsColor9 = "_l-c";
export var initialsWrapper = "_l-1";
export var large = "_l-l";
export var medium = "_l-k";
export var mediumSmall = "_l-j";
export var mediumSmallMedium = "_l-o";
export var micro = "_l-h";
export var small = "_l-i";
export var tiny = "_l-n";
export var xTiny = "_l-m";